export default {
  questionsArray: [],
  userAnswers: {},
  productAnswersArray: [],
  currentStep: "1",
  startAtStep: "1",
  matrixArray: [],
  userProductResults: {},
  likeliestProductsList: [],
  showSlidePostEnding: false,
  showSlidePreBegin: false,
  products: [],
  wineQuizRestUrls: {},
  currentEndingStep: "",
  endingSteps: ["storage", "result"],
  currentStartingStep: "",
  startingSteps: [],
  siteSettings: {
    height: "50vh",
    width: "50vw",
    background: "#f9f9f9",
    accent: "#0b6a6e",
    headingSize: "2em",
    headingColor: "#2c3e50",
    textSize: "18px",
    textColor: "#2c3e50",
    resultsText: "Based on your responses you might love...",
    resultsSharedText: "",
    leadCapture: "on",
    resultListNumber: 5
  },
  showLoader: false,
  disableUser: false,
  quiz: "",
  admin: false,
  imageFallBack:
    "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/1200px-No_image_available.svg.png",
  productMetaToShow: ["varietal", "vintage", "appellation"],
  user: {
    email: "",
    name: ""
  },
  debugInformation: {},
  retries: 5,
  addToCartFallBack: false,
  shareLinks: [],
  isOwnerOfResults: true,
  resultsSharedPageView: false
};
